<div class="cardWithShadow process-indicator-detail">
  <app-dynamic-form [formConfigs]="formConfigs" [formGroup]="formGroup" />
  @if (isAdmin) {
    <div class="flex justify-end gap-2!">
      <button mat-flat-button [disabled]="isLoading" (click)="onSubmit()">
        <div class="d-flex align-items-center text-disable">
          <app-loading-icon [loading]="isLoading" />
          {{ 'save' | translate }}
        </div>
      </button>
    </div>
  }
</div>
